import { observer } from "mobx-react-lite";
import React from "react";
import { ColumnLayout } from "~/components/ColumnLayout";
import { Screen } from "~/components/Screen";
import { Spacer } from "~/components/Spacer";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { useResponsive } from "../live-chat/useResponsive";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { SectionBokBokDatingApp2Images } from "./SectionBokBokDatingApp2Images";
import { SectionBokBokDatingAppText } from "./SectionBokBokDatingAppText";
import { SectionBokBokDatingAppTitle } from "./SectionBokBokDatingAppTitle";
import { SectionBokBokLiveApp2Images } from "./SectionBokBokLiveApp2Images";
import { SectionFeatures } from "./SectionFeatures";
import { SectionForm } from "./SectionForm";
import { StoreButtons } from "./StoreButtons";

export const HomeScreen = observer(function HomeScreen() {
  const r = useResponsive();

  const renderedDatingAppText = <SectionBokBokDatingAppText />;
  const renderedDatingAppImages = <SectionBokBokDatingApp2Images />;

  return (
    <Screen withBottomInset withTopInset>
      <Header />

      <View
        paddingExtraLarge={r(false, false, true)}
        style={{
          maxWidth: 1320,
          width: "100%",
          paddingBottom: styleConstants.spacingExtraLarge,
        }}
        alignSelfCenter
      >
        <ColumnLayout
          numColumns={r(1, 1, 2)}
          columnSeparator={<Spacer extraLarge />}
          rowSeparator={<Spacer extraLarge />}
        >
          <SectionForm />
          <SectionBokBokLiveApp2Images />
        </ColumnLayout>
        <Spacer extraLarge />
        <Spacer extraLarge />
      </View>

      <SectionFeatures />

      <View colorBackgroundLightDark>
        <View style={{ maxWidth: 1320, marginHorizontal: "auto" }}>
          <SectionBokBokDatingAppTitle />

          <View alignItemsFlexStart>
            <ColumnLayout numColumns={r(1, 1, 2)}>
              {r(
                renderedDatingAppText,
                renderedDatingAppText,
                renderedDatingAppImages,
              )}
              {r(
                renderedDatingAppImages,
                renderedDatingAppImages,
                renderedDatingAppText,
              )}
            </ColumnLayout>
            <StoreButtons />
          </View>
        </View>
        <Spacer extraLarge />
        <Spacer extraLarge />
      </View>

      <Footer />
    </Screen>
  );
});
